import React from 'react';
import { Route } from 'react-router-dom';

import { TrackedRoutes } from '../../components/TrackedRoutes';

import { UserList, UserProfile, CreateUser } from './components';

export const UsersPage: React.FC = () => {
  return (
    <TrackedRoutes>
      <Route index element={<UserList />} />
      <Route path="create" element={<CreateUser />} />
      <Route path=":userId" element={<UserProfile />} />
    </TrackedRoutes>
  );
};
